import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal, Table, Tooltip } from 'antd';
import Column from 'antd/es/table/Column';
import Title from 'antd/es/typography/Title';
import DownloadComponent from 'components/Global/Download';
import Ellipse from 'components/Global/Ellipse';
import { useSelector } from 'react-redux';
import { formatDate, invalidText } from 'utils/utils';
import './index.scss';

type HistoryProps = {
	open: boolean;
	closeModal: () => void;
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	allNhimaData: any;
	isLoading: boolean;
};

const ShareComponent = (data: any) => {
	const { record } = data;

	return (
		<Tooltip
			title={
				<>
					<p>EmployeeShare : {record.employeeShare} %</p>
					<p>EmployerShare : {record.employerShare} %</p>{' '}
				</>
			}
			placement="right"
		>
			{record.employerShare + record.employeeShare} %
		</Tooltip>
	);
};
const renderAgeDetails = (record: any) => {
	const details = (
		<div>
			<strong>Age limit :</strong>{' '}
			{record.ageLimit ? `${record.ageLimit} years` : '-'}
		</div>
	);

	return (
		<Tooltip title={details}>
			<Button type="link" style={{ color: '#584495' }}>
				View Details
			</Button>
		</Tooltip>
	);
};
const HistoryModal = (props: HistoryProps) => {
	const {
		open,
		closeModal,
		totalRecords,
		currentPage,
		pageSize,
		tableChangeHandler,
		allNhimaData,
		isLoading,
	} = props;

	const { data: profileData } = useSelector(
		(state: any) => state?.userProfile
	);

	return (
		<Modal
			open={open}
			maskClosable={true}
			width={1000}
			closable={false}
			footer={null}
			rootClassName="nhimaModalRoot"
		>
			<div className="modal-header">
				<Title level={4} className="modal-title">
					History
				</Title>
				<div className="close-icon" onClick={closeModal}>
					<CloseOutlined />
				</div>
			</div>
			<Table
				dataSource={allNhimaData}
				pagination={{
					total: totalRecords,
					current: currentPage,
					pageSize: pageSize,
					showSizeChanger: false,

					pageSizeOptions: [10, 20, 50, 100, 200],
				}}
				onChange={tableChangeHandler}
				rowKey={(record) => record.id}
				loading={isLoading}
			>
				<Column
					title="Effective Date"
					dataIndex="effectiveDate"
					key="effectiveDate"
					sorter={true}
					className="bg-white"
					render={(value) => {
						return formatDate(
							value,
							profileData?.companyDateFormat ?? 'DD/MM/YYYY'
						);
					}}
				/>
				<Column
					title="Percentage Share"
					key="employeeShare"
					dataIndex="employeeShare"
					className="bg-white"
					sorter={true}
					render={(_, record: any) => (
						<ShareComponent record={record} />
					)}
				/>
				<Column
					title="Updated By"
					dataIndex="createdBy"
					key="createdBy"
					className="bg-white"
					render={(text) => text?.fullName}
				/>
				<Column
					title="Notes"
					dataIndex="notes"
					key="notes"
					sorter={true}
					className="bg-white"
					render={(text, record: { id: string }) =>
						invalidText(text) ? (
							'-'
						) : (
							<Ellipse
								message={text}
								maxLength={20}
								key={record.id}
								tooltipMessage={text}
								isTooltip={true}
							/>
						)
					}
				/>
				<Column
					title="Attachment"
					dataIndex="attachment"
					key="attachment"
					className="bg-white"
					width={'18%'}
					render={(text, record: any) => (
						<div>
							{record.documentName ? (
								<div>
									<DownloadComponent
										documentUrl={record.documentUrl}
										showTooltip={true}
										downloadText={record.documentName}
										text={record.documentName}
										isLink={true}
										maxLength={20}
									/>
								</div>
							) : (
								'-'
							)}
						</div>
					)}
				/>
				<Column
					title="Other Details"
					dataIndex="createdAt"
					key="createdAt"
					className="bg-white"
					width={'16%'}
					render={(text, record: any) => renderAgeDetails(record)}
				/>
			</Table>
		</Modal>
	);
};

export default HistoryModal;
